"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryCharacteristicSIDefinitions = exports.BoundaryCharacteristicRelativeFieldPolicyMap = exports.BoundaryFieldValidationPolicy = exports.RatedBoundaryCharacteristics = exports.BoundaryCharacteristicSchema = exports.BoundaryCharacteristic = void 0;
const zod_1 = require("zod");
var BoundaryCharacteristic;
(function (BoundaryCharacteristic) {
    BoundaryCharacteristic["Voltage"] = "voltage";
    BoundaryCharacteristic["Current"] = "current";
    BoundaryCharacteristic["Temperature"] = "temperature";
    BoundaryCharacteristic["Power"] = "power";
    BoundaryCharacteristic["Frequency"] = "frequency";
    BoundaryCharacteristic["Inductance"] = "inductance";
    BoundaryCharacteristic["Resistance"] = "resistance";
    BoundaryCharacteristic["Capacitance"] = "capacitance";
    BoundaryCharacteristic["TemperatureKelvin"] = "temperatureKelvin";
})(BoundaryCharacteristic || (exports.BoundaryCharacteristic = BoundaryCharacteristic = {}));
exports.BoundaryCharacteristicSchema = zod_1.z.nativeEnum(BoundaryCharacteristic);
exports.RatedBoundaryCharacteristics = [
    BoundaryCharacteristic.Voltage,
    BoundaryCharacteristic.Current,
    BoundaryCharacteristic.Power,
];
var BoundaryFieldValidationPolicy;
(function (BoundaryFieldValidationPolicy) {
    BoundaryFieldValidationPolicy["Required"] = "required";
    BoundaryFieldValidationPolicy["Recommended"] = "recommended";
    BoundaryFieldValidationPolicy["Optional"] = "optional";
    BoundaryFieldValidationPolicy["Unexpected"] = "unexpected";
})(BoundaryFieldValidationPolicy || (exports.BoundaryFieldValidationPolicy = BoundaryFieldValidationPolicy = {}));
exports.BoundaryCharacteristicRelativeFieldPolicyMap = {
    [BoundaryCharacteristic.Voltage]: BoundaryFieldValidationPolicy.Recommended,
    [BoundaryCharacteristic.Power]: BoundaryFieldValidationPolicy.Required,
    [BoundaryCharacteristic.Current]: BoundaryFieldValidationPolicy.Unexpected,
    [BoundaryCharacteristic.Temperature]: BoundaryFieldValidationPolicy.Optional,
    [BoundaryCharacteristic.TemperatureKelvin]: BoundaryFieldValidationPolicy.Optional,
    [BoundaryCharacteristic.Frequency]: BoundaryFieldValidationPolicy.Unexpected,
    [BoundaryCharacteristic.Inductance]: BoundaryFieldValidationPolicy.Unexpected,
    [BoundaryCharacteristic.Resistance]: BoundaryFieldValidationPolicy.Unexpected,
    [BoundaryCharacteristic.Capacitance]: BoundaryFieldValidationPolicy.Unexpected,
};
exports.BoundaryCharacteristicSIDefinitions = {
    [BoundaryCharacteristic.Voltage]: {
        long: 'volts',
        short: 'V',
        alternateNames: ['volt'],
        usesSIPrefixes: true,
        epsilon: 1e-9,
    },
    [BoundaryCharacteristic.Current]: {
        long: 'amps',
        short: 'A',
        alternateNames: ['amperes', 'amp'],
        usesSIPrefixes: true,
        epsilon: 1e-9,
    },
    [BoundaryCharacteristic.Temperature]: {
        long: 'celsius',
        short: 'C',
        alternateNames: ['℃', 'ºc', 'ºC', 'º C', 'º c'],
        usesSIPrefixes: true,
        epsilon: 1e-6,
    },
    [BoundaryCharacteristic.TemperatureKelvin]: {
        long: 'kelvin',
        short: 'K',
        alternateNames: ['ºk', 'ºK', 'º K', 'º k'],
        usesSIPrefixes: true,
        epsilon: 1e-6,
    },
    [BoundaryCharacteristic.Power]: {
        long: 'watts',
        short: 'W',
        alternateNames: ['watt'],
        usesSIPrefixes: true,
        epsilon: 1e-9,
    },
    [BoundaryCharacteristic.Frequency]: {
        long: 'hertz',
        short: 'Hz',
        usesSIPrefixes: true,
        epsilon: 1e-6,
    },
    [BoundaryCharacteristic.Inductance]: {
        long: 'henry',
        short: 'H',
        usesSIPrefixes: true,
        epsilon: 1e-9,
    },
    [BoundaryCharacteristic.Capacitance]: {
        long: 'farad',
        short: 'F',
        usesSIPrefixes: true,
        epsilon: 1e-12,
    },
    [BoundaryCharacteristic.Resistance]: {
        long: 'ohm',
        short: 'Ω',
        usesSIPrefixes: true,
        epsilon: 1e-6,
    },
};
//# sourceMappingURL=BoundaryCharacteristic.js.map